import React, { memo, useMemo } from "react";
import { motion } from "framer-motion"; 

const CategoriesSection = memo(() => {
  const categories = useMemo(
    () => [
      { title: "Chemicals", img: "/img/scientist-adding-liquid-test-tube-600nw-2493601121.webp" },
      { title: "Equipment", img: "/img/Composites and Advanced Materials.webp" },
      { title: "Labware & Consumables", img: "/img/Labware and Consumables.webp" },
      { title: "Composites and Advanced Materials", img: "/img/Industrial Machinery.jpg" },
      { title: "Simulators", img: "/img/images.jpg" },
      { title: "Testing Instruments", img: "/img/Microscope.jpg" },
    ],
    []
  );

  return (
    <section className="py-24 bg-[#f8f9fb]" aria-labelledby="categories-heading">
      {/* Section Heading */}
      <div className="text-center mb-14">
        <h2
          id="categories-heading"
          className="text-2xl md:text-3xl font-light tracking-widest text-gray-700 uppercase"
        >
          Explore
        </h2>
        <h1 className="text-4xl md:text-5xl font-bold mt-2 leading-tight">
          Our <span className="text-[#B80000]">Categories</span>
        </h1>
        <div className="mt-3 w-24 h-[3px] bg-[#B80000] mx-auto rounded-full"></div>
      </div>

      {/* Categories Grid */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 px-6">
        {categories.map((category, index) => (
          <CategoryCard key={index} category={category} />
        ))}
      </div>
    </section>
  );
});

export default CategoriesSection;

// =======================
// CategoryCard Component
// =======================
const CategoryCard = memo(({ category }) => (
  <motion.div
    className="rounded-2xl overflow-hidden shadow-sm border border-gray-200 bg-white group hover:shadow-2xl transition-all duration-500"
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.5 }}
  >
    {/* ✅ Image Frame with Consistent Height & Hover Border */}
    <div className="relative overflow-hidden">
      <img
        src={category.img}
        alt={category.title}
        loading="lazy"
        decoding="async"
        className="w-full h-64 object-cover transform group-hover:scale-105 transition-transform duration-700"
        onError={(e) =>
          (e.currentTarget.src =
            "https://via.placeholder.com/800x400?text=Image+Not+Found")
        }
      />
      <div className="absolute inset-0 border-2 border-transparent group-hover:border-[#B80000] transition-all duration-500 rounded-2xl"></div>
    </div>

    {/* ✅ Title */}
    <div className="py-5 text-center bg-white">
      <h3 className="text-lg font-semibold text-gray-900 group-hover:text-[#B80000] transition-colors duration-300">
        {category.title}
      </h3>
    </div>
  </motion.div>
));
